var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseDetailedWeatherWidgetItem',_vm._b({style:({ 'background-color': _vm.temperatureColor })},'BaseDetailedWeatherWidgetItem',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }